import { SystemIcon } from '@volvo/vcdk-react/SystemIcon';

import { AreaName } from 'domain/constants';
import { TabConfiguration } from 'library/components/controls/layout/tabs/types';
import { OperationType } from 'library/models/enums/OperationType';
import { createArea } from 'library/utils/helpers/AreaHelper';
import {
	Drivelineview_Services_Repairs,
	Drivelineview_Services_ServiceProtocols,
} from 'main/routes/urls/RouteUrls';

export const drivelineServicesAreaTabsConfiguration: TabConfiguration[] = [
	{
		title: 'productIndividual:repairs-title',
		path: Drivelineview_Services_Repairs,
		icon: <SystemIcon icon="wrench" aria-label="Repairs" />,
		areaSecurity: createArea(AreaName.Repair, OperationType.Read),
	},
	{
		title: 'drivelineview:protocolsSection',
		path: Drivelineview_Services_ServiceProtocols,
		icon: <SystemIcon icon="service" aria-label="Service Protocols" />,
	},
];
